import { PlayIcon } from "@heroicons/react/solid";

const InfoCard = ({ image, title, genre, overview }) => {
  const truncate = (string, n) => {
    return string?.length > n ? string.substr(0, n - 1) + "..." : string;
  };
  return (
    <div
      style={{
        backgroundImage: `url("${image}")`,
        backgroundSize: "cover",
        height: "100vh",
        objectFit: "contain",

        position: "relative",
      }}
    >
      <div className="absolute left-0 mt-16 sm:ml-12 lg:ml-20">
        <div className="max-w-3xl flex flex-col">
          <div className="">
            <h1 className="text-6xl text-left font-extrabold text-gray-200 tracking-wider">
              {title}
            </h1>
          </div>
          <div className="mt-4">
            <h2 className="text-2xl tracking-wider text-left text-gray-200 font-bold">
              Genre: {genre}
            </h2>
          </div>
          <div className="mt-4">
            <h1 className="text-left text-lg max-w-md text-gray-100">
              {truncate(overview, 150)}
            </h1>
          </div>
          <div className="flex justify-start items-center space-x-3 mt-4">
            <div>
              <PlayIcon className=" h-16 text-green-400 shadow-lg hover:text-green-300" />
            </div>
            <div></div>
          </div>
        </div>
      </div>
      <div className="absolute w-full h-32 bg-gradient-to-t from-gray-800 to-transparent bottom-0 z-20" />
    </div>
  );
};

export default InfoCard;
